import React from 'react';

const BRAND_ASSETS = {
  primary: '/images/brand/sayable-wordmark.svg',
  reversed: '/images/brand/sayable-wordmark-reversed.svg',
  mark: '/images/brand/sayable-mark.svg',
  mono: '/images/brand/sayable-mark-mono.svg',
};

function BrandLogo({
  variant = 'primary',
  className = '',
  decorative = false,
  alt = 'Sayable.ai',
  ...imageProps
}) {
  const source = BRAND_ASSETS[variant] || BRAND_ASSETS.primary;

  return (
    <img
      {...imageProps}
      className={className}
      src={source}
      alt={decorative ? '' : alt}
      aria-hidden={decorative || undefined}
      decoding="async"
    />
  );
}

export { BRAND_ASSETS };
export default BrandLogo;
